<template>
  <a-input
    :value="modelValue"
    :placeholder="placeholder"
    :size="size"
    :class="inputClass"
    @update:value="handleInput"
    @keyup.enter="emit('pressEnter')"
  >
    <template #suffix>
      <a-button
        v-if="restSeconds === 0"
        type="link"
        :size="size"
        :disabled="disabled"
        @click="emit('send')"
      >
        <span :class="disabled ? disabledTextClass : activeTextClass">{{ sendText }}</span>
      </a-button>
      <span v-else :class="disabledTextClass"> {{ restSeconds }}s {{ retryText }} </span>
    </template>
  </a-input>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: string
    placeholder?: string
    restSeconds: number
    size?: 'small' | 'middle' | 'large'
    disabled?: boolean
    inputClass?: string
    sendText?: string
    retryText?: string
    activeTextClass?: string
    disabledTextClass?: string
  }>(),
  {
    placeholder: '请输入验证码',
    size: 'middle',
    disabled: false,
    inputClass: '',
    sendText: '获取验证码',
    retryText: '后重新获取',
    activeTextClass: 'code-normal',
    disabledTextClass: 'code-text',
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'send'): void
  (e: 'pressEnter'): void
}>()

function handleInput(value: string) {
  emit('update:modelValue', value)
}
</script>

<style scoped lang="less">
.code-text {
  font-size: 13px;
  color: rgb(191, 191, 191);
}

.code-normal {
  font-size: 13px;
  color: #268feb;
}
</style>
